<va-mat-table>
  <table mat-table [dataSource]="enabledProducts">
    <ng-container matColumnDef="productName">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'CUSTOMIZE_PARTNER.PRODUCT_SETTINGS.PRODUCT_NAME' | translate }}
      </th>
      <td mat-cell *matCellDef="let product">{{ product.name }}</td>
    </ng-container>

    <ng-container matColumnDef="editLink">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'CUSTOMIZE_PARTNER.PRODUCT_SETTINGS.CUSTOMIZE' | translate }}
      </th>
      <td mat-cell *matCellDef="let product">
        <a [routerLink]="customizeLinkForId[product.productId]">
          <mat-icon>edit</mat-icon>
        </a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
  </table>
</va-mat-table>
